import React, { useEffect, useState } from 'react';

import AiOptimizerOptionModal from '../createNew/AiOptimizerOptionModal';

import './AIButton.scss';

const EditAIOptimizerOptions = ({
    keywordData = {
        language_code: '',
        country_code: '',
        geo_location_obj: null,
        keywords: '',
        ai_content_type: null,
        ai_optimizer_options: null,
        ai_additional_info: '',
        ai_include_faqs: false,
    },
    onAIBriefOutlineEvent = () => {},
    isOptionModalOpen = false,
    handleOptionModalOpen = () => {},
    typeSelected = '',
}) => {
    const [aiOptimizerOptions, setAiOptimizerOptions] = useState({
        ai_content_type: null,
        ai_optimizer_options: null,
        ai_additional_info: '',
        ai_include_faqs: false,
    });
    const [isResetOptionModal, setIsResetOptionModal] = useState(false);

    useEffect(() => {
        setIsResetOptionModal(true);
        const { ai_content_type, ai_optimizer_options, ai_additional_info, ai_include_faqs } =
            keywordData || {};
        setAiOptimizerOptions((prev) => ({
            ...prev,
            ai_content_type: ai_content_type || null,
            ai_optimizer_options: ai_optimizer_options || null,
            ai_additional_info: ai_additional_info || '',
            ai_include_faqs: ai_include_faqs || false,
        }));
    }, [keywordData]);

    const handleSubmitAiForm = (aiFormData = {}) => {
        const { ai_content_type, ai_optimizer_options, ai_additional_info, ai_include_faqs } =
            aiFormData;

        handleOptionModalOpen();
        setAiOptimizerOptions((prev) => ({
            ...prev,
            ai_content_type,
            ai_optimizer_options,
            ai_additional_info,
            ai_include_faqs,
        }));
        onAIBriefOutlineEvent({
            ai_content_type,
            ai_optimizer_options,
            ai_additional_info,
            ai_include_faqs,
        });
        setIsResetOptionModal(true);
    };

    return (
        <div>
            <AiOptimizerOptionModal
                isOpen={isOptionModalOpen}
                handleOpen={handleOptionModalOpen}
                onSubmit={handleSubmitAiForm}
                resetFormData={isResetOptionModal}
                keywordData={{
                    language_code: keywordData.language_code,
                    country_code: keywordData.country_code,
                    keyword: keywordData.keywords,
                    location: keywordData.geo_location_obj,
                }}
                initialValues={aiOptimizerOptions}
                typeSelected={typeSelected}
            />
        </div>
    );
};

export default EditAIOptimizerOptions;
